import { initLanguagePopup } from './modules/language-popup';
import { initContentPopup } from './modules/popup';

initContentPopup();
initLanguagePopup();
